import { render, staticRenderFns } from "./Bill.vue?vue&type=template&id=65f8196e&scoped=true"
import script from "./Bill.vue?vue&type=script&lang=js"
export * from "./Bill.vue?vue&type=script&lang=js"
import style0 from "./Bill.vue?vue&type=style&index=0&id=65f8196e&prod&lang=less&scoped=true"
import style1 from "./Bill.vue?vue&type=style&index=1&id=65f8196e&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_cache-lo_675154ded190a7e2d3ad9efb69cc05e3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f8196e",
  null
  
)

export default component.exports